// Auto-generated per-query builders for ModelRequest
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ModelRequestReadAPI, ModelRequestWriteAPI, ModelRequestReadAPISchema, ModelRequestWriteAPISchema } from '../types/modelrequest';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, CreatedBy, HasModelRequestResponse, HasModelRequests, ToolResponsesSentIn, UsesSystemPromptForRequest } from '../../relationships/relationship';

import { ResponsePart } from './responsepart';
import { SecurityScope } from '../../shared/api/securityscope';
import { ToolCallResponse } from './toolcallresponse';
import { User } from '../../base/api/user';
import { SystemPrompt } from './systemprompt';
import { ModelResponse } from './modelresponse';
import { Step } from './step';



// Field names for order_by on ResponsePart
type ResponsePartFields = "created_at" | "-created_at" | "order_index" | "-order_index";



// Builder chain for query: chat-model-request-by-id

export interface ChatModelRequestByIdBuilder_0 {
  get(id: string): ChatModelRequestByIdBuilder_1;
  filter(conditions: { id: string }): ChatModelRequestByIdBuilder_1;
}

export interface ChatModelRequestByIdBuilder_1 {
  all(): Promise<ModelRequest[]>;
  first(): Promise<ModelRequest | null>;
  get(): Promise<ModelRequest[]>;
  execute(): Promise<ModelRequest[]>;
}

// Builder chain for query: chat-model-request-with-response

export interface ChatModelRequestWithResponseBuilder_0 {
  get(id: string): ChatModelRequestWithResponseBuilder_1;
  filter(conditions: { id: string }): ChatModelRequestWithResponseBuilder_1;
}

export interface ChatModelRequestWithResponseBuilder_1 {
  model_response: ChatModelRequestWithResponseBuilder_2;
}

export interface ChatModelRequestWithResponseBuilder_2 {
  parts: ChatModelRequestWithResponseBuilder_3;
}

export interface ChatModelRequestWithResponseBuilder_3 {
  orderBy(field?: ResponsePartFields): ChatModelRequestWithResponseBuilder_3;
  all(): Promise<ResponsePart[]>;
  first(): Promise<ResponsePart | null>;
  get(): Promise<ResponsePart[]>;
  execute(): Promise<ResponsePart[]>;
}


// Union of all query entry points
export type ModelRequestQueryBuilder = ChatModelRequestByIdBuilder_0 | ChatModelRequestWithResponseBuilder_0;

// Available query names for .setQuery()
export type ModelRequestQueryNames = "chat-model-request-by-id" | "chat-model-request-with-response";

// Type narrowing for .setQuery()
export type ModelRequestBuilderForQuery<Q extends ModelRequestQueryNames> =
  Q extends "chat-model-request-by-id" ? ChatModelRequestByIdBuilder_0
  : Q extends "chat-model-request-with-response" ? ChatModelRequestWithResponseBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ModelRequestInstanceQueryResult<Q extends ModelRequestQueryNames> =
  Q extends "chat-model-request-by-id" ? ChatModelRequestByIdBuilder_1
  : Q extends "chat-model-request-with-response" ? ChatModelRequestWithResponseBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'chat-model-request-by-id',
  'model_response|parts|order_by': 'chat-model-request-with-response',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ModelRequestQueryNames>(queryName: Q): ModelRequestBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}

Object.defineProperty(QueryBuilderImpl.prototype, 'model_response', {
  get() {
    return new QueryBuilderImpl('ModelResponse', [...this.path, 'model_response'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(QueryBuilderImpl.prototype, 'parts', {
  get() {
    return new QueryBuilderImpl('ResponsePart', [...this.path, 'parts'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});

export interface ModelRequest extends Partial<ModelRequestReadAPI> {}
export class ModelRequest extends NeoNodeBase<ModelRequestReadAPI, ModelRequestWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "ModelRequest";
  static readonly readSchema = ModelRequestReadAPISchema;
  static readonly writeSchema = ModelRequestWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    tool_return_parts: { target: "ToolCallResponse", cardinality: "many", isParent: false, relClass: "ToolResponsesSentIn", direction: "in" },
    created_by: { target: "User", cardinality: "one", isParent: false, relClass: "CreatedBy", direction: "out" },
    system_prompt: { target: "SystemPrompt", cardinality: "one", isParent: false, relClass: "UsesSystemPromptForRequest", direction: "out" },
    model_response: { target: "ModelResponse", cardinality: "one", isParent: false, relClass: "HasModelRequestResponse", direction: "out" },
    step: { target: "Step", cardinality: "one", isParent: true, relClass: "HasModelRequests", direction: "in" },
  };

  protected get modelName(): string {
    return 'ModelRequest';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return ModelRequest.label;
  }


  constructor(data: Partial<ModelRequestWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ModelRequestReadAPI, loadContext?: Record<string, any>): ModelRequest {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { created_by, system_prompt, model_response, step, security_scope, tool_return_parts, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ModelRequestReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, created_by: created_by, system_prompt: system_prompt, model_response: model_response, step: step, security_scope: security_scope, tool_return_parts: tool_return_parts };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return ModelRequest.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'created_by', 'User', ModelRegistry);
    loadOneRelationship(processed, 'system_prompt', 'SystemPrompt', ModelRegistry);
    loadOneRelationship(processed, 'model_response', 'ModelResponse', ModelRegistry);
    loadManyRelationship(processed, 'step', 'Step', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'tool_return_parts', 'ToolCallResponse', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new ModelRequest(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): ModelRequestQueryBuilder {
    return new QueryBuilderImpl('ModelRequest').filter(conditions) as any;
  }

  static all(): ModelRequestQueryBuilder {
    return new QueryBuilderImpl('ModelRequest') as any;
  }

  static async first(): Promise<ModelRequest | null> {
    const results = await new QueryBuilderImpl('ModelRequest').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ModelRequestQueryNames>(queryName: Q): ModelRequestBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('ModelRequest');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ModelRequestQueryNames>(queryName: Q): ModelRequestInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = ModelRequest.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'tool_return_parts' - Python ORM style (cached)
  get tool_return_parts(): RelationshipManager<this, ToolCallResponse> {
    return this.getOrCreateRelationshipManager('tool_return_parts', () => {
      return new RelationshipManager(this, 'tool_return_parts', 'many', ToolResponsesSentIn as typeof Relationship);
    });
  }

  // Relationship manager for 'created_by' - Python ORM style (cached)
  get created_by(): RelationshipManager<this, User> {
    return this.getOrCreateRelationshipManager('created_by', () => {
      return new RelationshipManager(this, 'created_by', 'one', CreatedBy as typeof Relationship);
    });
  }

  // Relationship manager for 'system_prompt' - Python ORM style (cached)
  get system_prompt(): RelationshipManager<this, SystemPrompt> {
    return this.getOrCreateRelationshipManager('system_prompt', () => {
      return new RelationshipManager(this, 'system_prompt', 'one', UsesSystemPromptForRequest as typeof Relationship);
    });
  }

  // Relationship manager for 'model_response' - Python ORM style (cached)
  get model_response(): RelationshipManager<this, ModelResponse> {
    return this.getOrCreateRelationshipManager('model_response', () => {
      return new RelationshipManager(this, 'model_response', 'one', HasModelRequestResponse as typeof Relationship);
    });
  }

  // Relationship manager for 'step' - Python ORM style (cached)
  get step(): RelationshipManager<this, Step> {
    return this.getOrCreateRelationshipManager('step', () => {
      return new RelationshipManager(this, 'step', 'one', HasModelRequests as typeof Relationship);
    });
  }

}
